import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DialogComponent } from "../components/dialogs/dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";

@Injectable()
export class DialogsService {
  constructor(private dialog: MatDialog) {}

  protected dialogConfig: any = {
    minWidth: "400px",
    minHeight: "200px"
  };
  public confirm(title: string, message: string): Observable<boolean> {
    let dialogRef: MatDialogRef<DialogComponent>;

    dialogRef = this.dialog.open(DialogComponent, this.dialogConfig);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.type = "confirmation";
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }
  public alert(
    title: string,
    message: string = "Something went wrong..."
  ): Observable<boolean> {
    let dialogRef: MatDialogRef<DialogComponent>;

    dialogRef = this.dialog.open(DialogComponent, this.dialogConfig);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.type = "alert";
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }
}
